
<div class="">
    <div class="items-start py-1.5 block sm:flex duration-200 border-b border-gray-700 dark:border-white/10 pb-2 mb-2">
        <img class="w-12 h-12 bg-white/10 p-3 mb-3 me-3 rounded-xl sm:mb-0 " src="{{imageUrl}}" alt="Laura"/>
        <div class=" dark:text-gray-400 text-sm space-y-0.5">
            <div class=" font-normal"><span class="  dark:text-white font-semibold mr-3 inline-block">{{userName}}</span> <span class=" text-xs  dark:text-white">{{userPost}}</span></div>
            <div class=" text-gray-400 dark:text-white">{{discription}}</div>
            <div class="flex justify-between items-center">
                <span class="font-semibold text-xs dark:text-white flex items-start">      
                    {{ datePost | appDate }}
                </span>
            </div>
        </div>
    </div>
</div>
